import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../../services/whatsapp.service";
import {
  IGetWhatsappConversationsParams,
  ISendWhatsappMessageParams,
  ISendWhatsappFilesParams,
  IGetWhatsappStatsParams,
  IGetWhatsappMessageStatsParams,
} from "../../models/whatsapp.model";

export const getWhatsappConversationsThunk = createAsyncThunk(
  "whatsapp/getConversations",
  async (params: IGetWhatsappConversationsParams, { rejectWithValue }) => {
    try {
      const response = await api.getWhatsappConversations(params);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get WhatsApp conversations failed"
      );
    }
  }
);

export const getWhatsappConversationByIdThunk = createAsyncThunk(
  "whatsapp/getConversationById",
  async (
    arg: string | { id: string; markRead?: boolean; campaign_id?: string },
    { rejectWithValue }
  ) => {
    const { id, markRead, campaign_id } =
      typeof arg === "string"
        ? { id: arg, markRead: false, campaign_id: undefined }
        : arg;
    try {
      const response = await api.getWhatsappConversationById(id, markRead, {
        campaign_id,
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get WhatsApp conversation failed"
      );
    }
  }
);

export const sendWhatsappMessageThunk = createAsyncThunk(
  "whatsapp/sendMessage",
  async (params: ISendWhatsappMessageParams, { rejectWithValue }) => {
    try {
      const response = await api.sendWhatsappMessage(params);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Send WhatsApp message failed"
      );
    }
  }
);

export const sendWhatsappFilesThunk = createAsyncThunk(
  "whatsapp/sendFiles",
  async (params: ISendWhatsappFilesParams, { rejectWithValue }) => {
    try {
      const response = await api.sendWhatsappFiles(params);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Send WhatsApp files failed"
      );
    }
  }
);

export const updateWhatsappConversationStatusThunk = createAsyncThunk(
  "whatsapp/updateStatus",
  async (
    { id, status }: { id: string; status: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.updateWhatsappConversationStatus(id, status);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Update WhatsApp conversation status failed"
      );
    }
  }
);

export const assignWhatsappConversationThunk = createAsyncThunk(
  "whatsapp/assign",
  async (
    { id, assigned_to }: { id: string; assigned_to: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.assignWhatsappConversation(id, assigned_to);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Assign WhatsApp conversation failed"
      );
    }
  }
);

export const getWhatsappStatsThunk = createAsyncThunk(
  "whatsapp/getStats",
  async (params: IGetWhatsappStatsParams, { rejectWithValue }) => {
    try {
      const response = await api.getWhatsappStats(params);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get WhatsApp stats failed"
      );
    }
  }
);


export const getWhatsappMessageStatsThunk = createAsyncThunk(
  "whatsapp/getMessageStats",
  async (params: IGetWhatsappMessageStatsParams, { rejectWithValue }) => {
    try {
      const response = await api.getWhatsappMessageStats(params);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get WhatsApp message stats failed"
      );
    }
  }
);